import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ReactHtmlParser from 'html-react-parser';

function Description({key, description, ar_description, language}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [fontSize, setFontSize] = useState("16px");
  const [lineHeight, setLineHeight] = useState("1.5");

  const toggleExpand = () => setIsExpanded(!isExpanded);
  const lang = language || '';
  
  useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia("(max-width: 640px)").matches) {
        setFontSize("10px");
        setLineHeight("1.6");
      } else {
        setFontSize("18px");
        setLineHeight("1.5");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [description, ar_description]);

  const currentDescription = lang === 'ar' ? ar_description : description;
  const isRTL = lang === 'ar';  // Determine if we need RTL layout

  const styledDescription = currentDescription?.replace(
    /<span[^>]*>/g,
    `<span style="font-size: ${fontSize}; line-height: ${lineHeight};">`
  );

  const sanitizedDescription =
    typeof styledDescription === "string" ? styledDescription : "";

  // Calculate rotation for chevron icon based on language and state
  const iconRotation = isExpanded 
    ? 90 
    : isRTL 
      ? 180 
      : 0;

  return (
    <div key={key} dir={isRTL ? 'rtl' : 'ltr'}>
      <div className={`relative max-w-full ${isRTL ? 'text-right' : 'text-left'}`}>
        <div
          className={`overflow-hidden transition-max-height duration-300 ease-in-out ${
            isExpanded ? 'max-h-[10000000px]' : 'max-h-40'
          }`}
        >
          <div
            className={`text-[20px] max-sm:text-[13px] leading-6 max-sm:leading-5 ${
              isRTL ? 'rtl-text-direction' : ''
            }`}
            dangerouslySetInnerHTML={{
              __html: `<span class="override-html">${sanitizedDescription}</span>`,
            }}
          ></div>
        </div>
        
        {!isExpanded && (
          <div className="absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
        )}
      </div>
      
      <div className={`flex justify-center mt-8 max-sm:mt-4 ${isRTL ? 'flex-row-reverse' : ''}`}>
        <button
          onClick={toggleExpand}
          className={`text-[#804df8] font-medium max-sm:text-[12px] flex items-center ${
            isRTL ? 'flex-row-reverse' : ''
          }`}
        >
          {isExpanded
            ? isRTL
              ? 'قراءة أقل'    // "Read Less" in Arabic
              : 'Read Less'
            : isRTL
            ? 'قراءة المزيد'  // "Read More" in Arabic
            : 'Read More'}
          
          <ChevronRightIcon 
            style={{ 
              transform: `rotate(${iconRotation}deg)`,
              transition: 'transform 0.3s ease',
              marginLeft: isRTL ? 0 : '4px',
              marginRight: isRTL ? '4px' : 0
            }} 
          />
        </button>
      </div>
    </div>
  );
}

export default Description;